import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";


import { ReactComponent as ActiveImg } from "../../../img/ico-status-stable.svg";
import { ReactComponent as ErrorImg } from "../../../img/ico-status-error.svg";
import { ReactComponent as AlertImg } from "../../../img/ico-status-alert.svg";
import { ReactComponent as IdleImg } from "../../../img/ico-status-block.svg";

import { ReactComponent as RunningImg } from "../../../img/ico-account-sleeper.svg";
import { ReactComponent as DownImg } from "../../../img/ico-account-idle.svg";
import { ReactComponent as LockImg } from "../../../img/ico-prefix-lock.svg";
import { ReactComponent as UnlockImg } from "../../../img/ico-prefix-unlock.svg";

import VmAdd from "./VmAdd";

import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { getTimestampToDate } from "../../../common/util";


export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("ADD_VOLUME_CONNECT_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "VOLUME_ADD",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 3,
        name: i18n.t("DISCONNECT_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "VOLUME_DELETE",
        },
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("VM_VOLUME_NAME_TEXT"),
        accessor: "volume_name",
        disableSortBy: true,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("DESCRIPTION_TEXT"),
        accessor: "volume_description",
        disableSortBy: false,
        style: {
            width: "140px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#5c5c5c"}}>{value}</div>)
    },
    {
        Header: i18n.t("VM_VOLUME_SIZE_TEXT"),
        accessor: "volume_size_gb",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#0853fb"}}>{value} GB</div>)
    },
    {
        Header: i18n.t("VM_VOLUME_MOUNT_DEVICE_TEXT"),
        accessor: "mapping_device_name",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#3a8344"}}>{value}</div>)
    },
    {
        Header: i18n.t("BOOT_AVAILABLE_TEXT"),
        accessor: "boot_yn",
        disableSortBy: true,
        style: {
            width: "70px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, color: "#0853fb"}}>{value ? 'Y' : 'N'}</div>)
    }
];

const className = {
    rowContainer: {
        width: "100%"
    },
    statusContainer: {
        width: "100px",
        display: "flex",
        alignItems: "center",
    },
    statusInnerContainer: {
        display: "flex", alignItems: "center",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        lineHeight: "1",
        color: "#9ea0a5",
        overflow: "hidden"
    },
    usageTypeContainerService: {
        width: 48, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#5b9782",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#fff",
    },
    usageTypeContainerContNode: {
        width: 120, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#f5ddd0",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#cc7e52",
    },
    usageTypeContainerManagement: {
        width: 90, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#fbefc9",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#92782f",
    },
    usageTypeContainerUnknown: {
        width: 48, height: 20,
        borderRadius: 4,
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: "#c1c7cc",
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#fff",
    },
}